import '../../assets/index52.css';var q = Object.defineProperty, K = Object.defineProperties;
var W = Object.getOwnPropertyDescriptors;
var I = Object.getOwnPropertySymbols;
var E = Object.prototype.hasOwnProperty, V = Object.prototype.propertyIsEnumerable;
var H = (t, e, r) => e in t ? q(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, m = (t, e) => {
  for (var r in e || (e = {}))
    E.call(e, r) && H(t, r, e[r]);
  if (I)
    for (var r of I(e))
      V.call(e, r) && H(t, r, e[r]);
  return t;
}, b = (t, e) => K(t, W(e));
var h = (t, e) => {
  var r = {};
  for (var o in t)
    E.call(t, o) && e.indexOf(o) < 0 && (r[o] = t[o]);
  if (t != null && I)
    for (var o of I(t))
      e.indexOf(o) < 0 && V.call(t, o) && (r[o] = t[o]);
  return r;
};
import { jsx as i, jsxs as D } from "react/jsx-runtime";
import { useState as j, useEffect as U, forwardRef as G } from "react";
import { Button as T } from "../Button/index.js";
import { Title as J } from "../Title/index.js";
import { XMarkFarFAIcon as L } from "../Icons/index.js";
import { g as $ } from "../../OptionalPortal-sP4Hf4UO.js";
import { f as g, u as x } from "../../factory-ueRxoNOV.js";
import { M as Q, a as Y, N as ee, b as te, c as re, d as oe, e as se, f as ae } from "../../NativeScrollArea-6YYAn0l3.js";
import { c as ne } from "../../create-safe-context-DqDyoPVE.js";
import { r as le } from "../../rem-CMQJ_ZTp.js";
import { c as ce } from "../../get-size-Bc1Pz5yf.js";
import { c as ie } from "../../create-vars-resolver-Bzbn9G-G.js";
import { u as de } from "../../use-styles-DToiHEa6.js";
import { u as me } from "../../DirectionProvider-CT8S13Cp.js";
import { S as ue } from "../../ScrollArea-BFbb1tLv.js";
import { c as pe } from "../../create-optional-context-CQ2ahjKQ.js";
import { S as fe } from "../../Stack-CTaaXTID.js";
const [we, k] = ne(
  "Drawer component was not found in tree"
);
var v = { root: "m_f11b401e", header: "m_5a7c2c9", content: "m_b8a05bbd", inner: "m_31cd769a" };
const ye = {}, A = g((t, e) => {
  const a = x("DrawerBody", ye, t), { classNames: o, className: u, style: n, styles: l, vars: d } = a, p = h(a, ["classNames", "className", "style", "styles", "vars"]), s = k();
  return /* @__PURE__ */ i(
    Q,
    m(m({
      ref: e
    }, s.getStyles("body", { classNames: o, style: n, styles: l, className: u })), p)
  );
});
A.classes = v;
A.displayName = "@mantine/core/DrawerBody";
const he = {}, M = g((t, e) => {
  const a = x("DrawerCloseButton", he, t), { classNames: o, className: u, style: n, styles: l, vars: d } = a, p = h(a, ["classNames", "className", "style", "styles", "vars"]), s = k();
  return /* @__PURE__ */ i(
    Y,
    m(m({
      ref: e
    }, s.getStyles("close", { classNames: o, style: n, styles: l, className: u })), p)
  );
});
M.classes = v;
M.displayName = "@mantine/core/DrawerCloseButton";
const _e = {}, O = g((t, e) => {
  const _ = x("DrawerContent", _e, t), { classNames: o, className: u, style: n, styles: l, vars: d, children: p, radius: s, __hidden: a } = _, S = h(_, ["classNames", "className", "style", "styles", "vars", "children", "radius", "__hidden"]), c = k(), B = c.scrollAreaComponent || ee;
  return /* @__PURE__ */ i(
    te,
    b(m(b(m({}, c.getStyles("content", { className: u, style: n, styles: l, classNames: o })), {
      innerProps: c.getStyles("inner", { className: u, style: n, styles: l, classNames: o }),
      ref: e
    }), S), {
      radius: s || c.radius || 0,
      "data-hidden": a || void 0,
      children: /* @__PURE__ */ i(B, { style: { height: "calc(100vh - var(--drawer-offset) * 2)" }, children: p })
    })
  );
});
O.classes = v;
O.displayName = "@mantine/core/DrawerContent";
const ve = {}, z = g((t, e) => {
  const a = x("DrawerHeader", ve, t), { classNames: o, className: u, style: n, styles: l, vars: d } = a, p = h(a, ["classNames", "className", "style", "styles", "vars"]), s = k();
  return /* @__PURE__ */ i(
    re,
    m(m({
      ref: e
    }, s.getStyles("header", { classNames: o, style: n, styles: l, className: u })), p)
  );
});
z.classes = v;
z.displayName = "@mantine/core/DrawerHeader";
const De = {}, F = g((t, e) => {
  const a = x("DrawerOverlay", De, t), { classNames: o, className: u, style: n, styles: l, vars: d } = a, p = h(a, ["classNames", "className", "style", "styles", "vars"]), s = k();
  return /* @__PURE__ */ i(
    oe,
    m(m({
      ref: e
    }, s.getStyles("overlay", { classNames: o, style: n, styles: l, className: u })), p)
  );
});
F.classes = v;
F.displayName = "@mantine/core/DrawerOverlay";
function ge(t) {
  switch (t) {
    case "top":
      return "flex-start";
    case "bottom":
      return "flex-end";
    default:
      return;
  }
}
function xe(t) {
  if (t === "top" || t === "bottom")
    return "0 0 calc(100% - var(--drawer-offset, 0rem) * 2)";
}
const Se = {
  top: "slide-down",
  bottom: "slide-up",
  left: "slide-right",
  right: "slide-left"
}, Ne = {
  top: "slide-down",
  bottom: "slide-up",
  right: "slide-right",
  left: "slide-left"
}, Be = {
  closeOnClickOutside: !0,
  withinPortal: !0,
  lockScroll: !0,
  trapFocus: !0,
  returnFocus: !0,
  closeOnEscape: !0,
  keepMounted: !1,
  zIndex: $("modal"),
  position: "left"
}, Ce = ie((t, { position: e, size: r, offset: o }) => ({
  root: {
    "--drawer-size": ce(r, "drawer-size"),
    "--drawer-flex": xe(e),
    "--drawer-height": e === "left" || e === "right" ? void 0 : "var(--drawer-size)",
    "--drawer-align": ge(e),
    "--drawer-justify": e === "right" ? "flex-end" : void 0,
    "--drawer-offset": le(o)
  }
})), R = g((t, e) => {
  const r = x("DrawerRoot", Be, t), f = r, {
    classNames: o,
    className: u,
    style: n,
    styles: l,
    unstyled: d,
    vars: p,
    scrollAreaComponent: s,
    position: a,
    transitionProps: S,
    radius: c
  } = f, B = h(f, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "scrollAreaComponent",
    "position",
    "transitionProps",
    "radius"
  ]), { dir: _ } = me(), C = de({
    name: "Drawer",
    classes: v,
    props: r,
    className: u,
    style: n,
    classNames: o,
    styles: l,
    unstyled: d,
    vars: p,
    varsResolver: Ce
  }), N = (_ === "rtl" ? Ne : Se)[a];
  return /* @__PURE__ */ i(we, { value: { scrollAreaComponent: s, getStyles: C, radius: c }, children: /* @__PURE__ */ i(
    se,
    m(b(m({
      ref: e
    }, C("root")), {
      transitionProps: m({ transition: N }, S),
      "data-offset-scrollbars": s === ue.Autosize || void 0,
      unstyled: d
    }), B)
  ) });
});
R.classes = v;
R.displayName = "@mantine/core/DrawerRoot";
const [be, ke] = pe();
function X({ children: t }) {
  const [e, r] = j([]), [o, u] = j($("modal"));
  return /* @__PURE__ */ i(
    be,
    {
      value: {
        stack: e,
        addModal: (n, l) => {
          r((d) => [.../* @__PURE__ */ new Set([...d, n])]), u(
            (d) => typeof l == "number" && typeof d == "number" ? Math.max(d, l) : d
          );
        },
        removeModal: (n) => r((l) => l.filter((d) => d !== n)),
        getZIndex: (n) => `calc(${o} + ${e.indexOf(n)} + 1)`,
        currentId: e[e.length - 1],
        maxZIndex: o
      },
      children: t
    }
  );
}
X.displayName = "@mantine/core/DrawerStack";
const Pe = {}, Z = g((t, e) => {
  const a = x("DrawerTitle", Pe, t), { classNames: o, className: u, style: n, styles: l, vars: d } = a, p = h(a, ["classNames", "className", "style", "styles", "vars"]), s = k();
  return /* @__PURE__ */ i(
    ae,
    m(m({
      ref: e
    }, s.getStyles("title", { classNames: o, style: n, styles: l, className: u })), p)
  );
});
Z.classes = v;
Z.displayName = "@mantine/core/DrawerTitle";
const Ie = {
  closeOnClickOutside: !0,
  withinPortal: !0,
  lockScroll: !0,
  trapFocus: !0,
  returnFocus: !0,
  closeOnEscape: !0,
  keepMounted: !1,
  zIndex: $("modal"),
  withOverlay: !0,
  withCloseButton: !0
}, y = g((t, e) => {
  const N = x("Drawer", Ie, t), {
    title: r,
    withOverlay: o,
    overlayProps: u,
    withCloseButton: n,
    closeButtonProps: l,
    children: d,
    opened: p,
    stackId: s,
    zIndex: a
  } = N, S = h(N, [
    "title",
    "withOverlay",
    "overlayProps",
    "withCloseButton",
    "closeButtonProps",
    "children",
    "opened",
    "stackId",
    "zIndex"
  ]), c = ke(), B = !!r || n, _ = c && s ? {
    closeOnEscape: c.currentId === s,
    trapFocus: c.currentId === s,
    zIndex: c.getZIndex(s)
  } : {}, C = o === !1 ? !1 : s && c ? c.currentId === s : p;
  return U(() => {
    c && s && (p ? c.addModal(s, a || $("modal")) : c.removeModal(s));
  }, [p, s, a]), /* @__PURE__ */ D(
    R,
    b(m(m({
      ref: e,
      opened: p,
      zIndex: c && s ? c.getZIndex(s) : a
    }, S), _), {
      children: [
        o && /* @__PURE__ */ i(
          F,
          m({
            visible: C,
            transitionProps: c && s ? { duration: 0 } : void 0
          }, u)
        ),
        /* @__PURE__ */ D(O, { __hidden: c && s && p ? s !== c.currentId : !1, children: [
          B && /* @__PURE__ */ D(z, { children: [
            r && /* @__PURE__ */ i(Z, { children: r }),
            n && /* @__PURE__ */ i(M, m({}, l))
          ] }),
          /* @__PURE__ */ i(A, { children: d })
        ] })
      ]
    })
  );
});
y.classes = v;
y.displayName = "@mantine/core/Drawer";
y.Root = R;
y.Overlay = F;
y.Content = O;
y.Body = A;
y.Header = z;
y.Title = Z;
y.CloseButton = M;
y.Stack = X;
const $e = "Drawer-module__root___vFdaU", Ae = "Drawer-module__overlay___SFmaB", Me = "Drawer-module__inner___9vZ6X", Oe = "Drawer-module__content___64cRZ", ze = "Drawer-module__headerSection___519PP", Fe = "Drawer-module__title___77ung", Re = "Drawer-module__description___UBfK4", Ze = "Drawer-module__closeButton___n286r", Te = "Drawer-module__body___VaoqR", He = "Drawer-module__footer___4-M3H", Ee = "Drawer-module__leftActions___IVCFk", Ve = "Drawer-module__rightActions___-t96V", w = {
  root: $e,
  overlay: Ae,
  inner: Me,
  content: Oe,
  headerSection: ze,
  title: Fe,
  description: Re,
  closeButton: Ze,
  body: Te,
  footer: He,
  leftActions: Ee,
  rightActions: Ve
}, je = {
  xs: 320,
  sm: 380,
  md: 440,
  lg: 620,
  xl: 780
}, Ue = G((B, c) => {
  var _ = B, {
    "data-plum-id": t,
    opened: e,
    onClose: r,
    title: o,
    description: u,
    size: n = "md",
    position: l = "right",
    actions: d = [],
    children: p,
    className: s,
    classNames: a = {}
  } = _, S = h(_, [
    "data-plum-id",
    "opened",
    "onClose",
    "title",
    "description",
    "size",
    "position",
    "actions",
    "children",
    "className",
    "classNames"
  ]);
  U(() => (e && (document.body.style.overflow = "hidden"), () => {
    document.body.style.overflow = "unset";
  }), [e]);
  const C = d.filter((f) => f.position === "left"), N = d.filter((f) => f.position !== "left");
  return /* @__PURE__ */ i(
    y,
    b(m({
      ref: c,
      opened: e,
      onClose: r,
      position: l,
      size: je[n],
      classNames: m({
        root: `${w.root} ${a.root || ""}`,
        overlay: `${w.overlay} ${a.overlay || ""}`,
        body: `${w.body} ${a.body || ""}`,
        header: `${w.header} ${a.header || ""}`
      }, a),
      withCloseButton: !1,
      "data-plum-id": t
    }, S), {
      children: /* @__PURE__ */ D("div", { className: w.inner, children: [
        /* @__PURE__ */ D("div", { className: w.content, children: [
          /* @__PURE__ */ D("div", { className: w.headerSection, children: [
            /* @__PURE__ */ D(fe, { gap: "xs", w: "100%", children: [
              o && /* @__PURE__ */ i(J, { order: 4, className: w.title, children: o }),
              u && /* @__PURE__ */ i("p", { className: w.description, children: u })
            ] }),
            /* @__PURE__ */ i(
              T,
              {
                className: w.closeButton,
                onClick: r,
                variant: "tertiary",
                size: "sm",
                children: /* @__PURE__ */ i(L, {})
              }
            )
          ] }),
          p
        ] }),
        d.length > 0 && /* @__PURE__ */ D("div", { className: w.footer, children: [
          /* @__PURE__ */ i("div", { className: w.leftActions, children: C.map((f, P) => /* @__PURE__ */ i(
            T,
            {
              onClick: f.onClick,
              variant: f.variant || "tertiary",
              "data-danger": f.danger,
              children: f.label
            },
            P
          )) }),
          /* @__PURE__ */ i("div", { className: w.rightActions, children: N.map((f, P) => /* @__PURE__ */ i(
            T,
            {
              onClick: f.onClick,
              variant: f.variant || (P === N.length - 1 ? "accent" : "primary"),
              "data-danger": f.danger,
              children: f.label
            },
            P
          )) })
        ] })
      ] })
    })
  );
});
Ue.displayName = "Drawer";
export {
  Ue as Drawer
};
